import { FindingSignature, ReviewFinding } from './requests';

export const findingSignature = (finding: ReviewFinding): FindingSignature => ({
  category: finding.category,
  targetId: finding.target.id,
  issueKey: finding.issueKey,
  subject: finding.subject,
  title: finding.title,
  contentHash: finding.contentHash,
});

// The title is absent because the model rewrites it every run. The subject is not:
// it names which thing on the target, so siblings stay separable.
export const signatureKey = (signature: FindingSignature) =>
  `${signature.category}:${signature.targetId ?? ''}:${signature.issueKey}:${normalizeSubject(
    signature.subject
  )}`;

// Mirrors _normalize_subject in apps/journey_reviews/signatures.py.
const normalizeSubject = (subject: string) => subject.trim().split(/\s+/).join(' ').toLowerCase();
